// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileForm_form__i_Roa","control":"ProfileForm_control__2Mvm6","action":"ProfileForm_action__3xLUj"};